import { render, staticRenderFns } from "./Flex.global.vue?vue&type=template&id=7000910e&scoped=true&lang=pug&"
import script from "./Flex.global.vue?vue&type=script&lang=ts&"
export * from "./Flex.global.vue?vue&type=script&lang=ts&"
import style0 from "./Flex.global.vue?vue&type=style&index=0&id=7000910e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7000910e",
  null
  
)

export default component.exports